import axiosInstance from "api/utils/axiosInstance";
import { URLS } from "api/utils/baseUrls";
import { constructSearchParams } from "utils/constructSearchParams";
import { FieldAnalysisReportDto } from "api/dtos/FieldAnalysisReportDto";

const getReport = async ({ fieldId, cropId, isBio, analysisDate }) => {
  const { data } = await axiosInstance.post(
    `${URLS.externalRequests}/field-analysis/report/`,
    { fieldId, cropId, isBio, analysisDate }
  );
  return FieldAnalysisReportDto.fromApi(data);
};

const getReports = async ({ fieldId, page, pageSize, dateFrom, dateTo }) => {
  const params = constructSearchParams({
    fieldId,
    page,
    pageSize,
    dateFrom,
    dateTo,
  });
  const { data } = await axiosInstance.get(
    `${URLS.externalRequests}/field-analysis/reports/`,
    { params }
  );
  return FieldAnalysisReportDto.fromApiList(data);
};

export const fieldAnalysisApi = {
  fetchReport: getReport,
  fetchReports: getReports,
};
